'use client';

import NotFoundPage from '@/components/templates/shared/NotFoundPage';

export default function NotFound() {
  return <NotFoundPage />;
}
